import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { findGameBySlug, gameSlug } from '../utils/gameSlug.js';
import { routeGameSlug } from '../authentication/routeGameAccess.js';
import { findPortfolioBySlug, portfolioSlug, routePortfolioSlug } from './portfolioScopeNav.jsx';

// Swaps an old, bare-id or pre-rename link for the item's current one: same page, same query, no new history entry.
const useCanonicalLink = (segmentOfPath, items, find, segmentOf) => {
    const location = useLocation();
    const navigate = useNavigate();
    const segment = segmentOfPath(location.pathname);
    const item = segment ? find(items, segment) : null;
    const canonical = item ? segmentOf(item) : null;

    useEffect(() => {
        if (!canonical || canonical === segment) return;
        const parts = location.pathname.split('/');
        parts[2] = encodeURIComponent(canonical);
        navigate(`${parts.join('/')}${location.search}${location.hash}`, { replace: true, state: location.state });
    }, [canonical, segment, location, navigate]);
};

export const CanonicalGameLink = () => {
    useCanonicalLink(routeGameSlug, useSelector((state) => state.userGames), findGameBySlug, gameSlug);
    return null;
};

export const CanonicalPortfolioLink = () => {
    useCanonicalLink(routePortfolioSlug, useSelector((state) => state.userPortfolios), findPortfolioBySlug, portfolioSlug);
    return null;
};
